<template>
    <div>
        <div class="main-content bg-white" v-if="$currentUser.role != 'admin'">
            <span class="alert-danger">У вас нет доступа к этой странице.</span>
        </div>
        <div class="main-content bg-white" v-if="$currentUser.role == 'admin'">
            <div class="page-header">
                <h3 class="page-title">Логи</h3>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div v-if="!isMobile">
                        <b-table hover responsive bordered
                                 small
                                 :items="logs"
                                 :fields="fields"
                                 no-local-sorting
                                 :sort-by.sync="sortBy"
                                 @sort-changed="getLogs(1, $event, search)"
                                 :sort-desc.sync="sortDesc"
                                 :sort-direction="sortDirection">
                            <template v-slot:cell(description)="row">
                                <span v-if="row.item.description == 'deleted'">Удалено</span>
                                <span v-if="row.item.description == 'updated'">Обновлено</span>
                            </template>
                            <template v-slot:cell(actions)="row">
                                <b-button size="sm" class="btn btn-primary"
                                          style="color: #fff;background-color: #007dcc;border-color: #007dcc;"
                                          v-bind:href="'/log/' + row.item.id">
                                    <i class="icon-fa icon-fa-eye"></i>
                                </b-button>
                            </template>
                        </b-table>
                    </div>
                    <div v-if="isMobile">
                        <b-table hover responsive bordered stacked
                                 small
                                 :items="logs"
                                 :fields="fields"
                                 no-local-sorting
                                 :sort-by.sync="sortBy"
                                 @sort-changed="getLogs(1, $event, search)"
                                 :sort-desc.sync="sortDesc"
                                 :sort-direction="sortDirection">
                            <template v-slot:cell(description)="row">
                               <span v-if="row.item.description == 'deleted'">Удалено</span>
                                <span v-if="row.item.description == 'updated'">Обновлено</span>
                            </template>
                            <template v-slot:cell(actions)="row">
                                <b-button size="sm" class="btn btn-primary"
                                          style="color: #fff;background-color: #007dcc;border-color: #007dcc;"
                                          v-bind:href="'/log/' + row.item.id">
                                    <i class="icon-fa icon-fa-eye"></i>
                                </b-button>
                            </template>
                        </b-table>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-5">
                    <div class="" role="status" aria-live="polite">Всего записей: {{ pager.total }}</div>
                </div>
                <div class="col-sm-7">
                    <div class="float-right">
                        <nav aria-label="Page navigation">
                            <ul class="pagination justify-content-center">
                                <b-pagination size="sm" :total-rows="pager.total"
                                              v-model="pager.current_page"
                                              v-on:change="getLogs($event, {sortBy: sortBy, sortDesc: sortDesc}, search)"
                                              :per-page="pager.per_page"></b-pagination>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import LogsService from '../../services/logsDataService'

    export default {
        name: 'logs',
        components: {},
        data() {
            return {
                logs: [],
                pager: {},
                user: null,
                pageSize: 50,
                fields: [
                    {
                        key: 'subject_id',
                        label: 'Сущность',
                        sortable: true
                    },
                    {
                        key: 'parsedSubjectType',
                        label: 'Название сущности',
                        sortable: true
                    },
                    {
                        key: 'created_at',
                        label: 'Дата изменения',
                        sortable: true
                    },
                    {
                        key: 'name',
                        label: 'Пользователь',
                        sortable: true
                    },
                    // {
                    //     key: 'description',
                    //     label: 'Изменение'
                    // },
                    {
                        key: 'actions',
                        label: 'Действия',
                        tdAttr: {'align': "center"}
                    }
                ],
                search: '',
                sortBy: 'created_at',
                sortDesc: true,
                sortDirection: 'desc',
                isMobile: false,
                window: {
                    width: 0,
                    height: 0
                },
                isXl: false
            }
        },
        methods: {
            getLogs (page, sort) {
                if (!page) {
                    page = 1
                }

                if (!sort) {
                    sort = this
                }

                if (this.isMobile) {
                    this.pageSize = 10
                }

                LogsService.getLogs(page, sort, false, this.pageSize)
                    .then(logs => {
                        this.pager = logs;
                        this.logs = logs.data
                    })

            },
            handleResize() {
                this.window.width = window.innerWidth;
                this.window.height = window.innerHeight;

                if (this.window.width < 415) {
                    this.isMobile = true
                } else {
                    this.isMobile = false
                }

                if (this.window.width > 1199) {
                    this.isXl = true
                } else {
                    this.isXl = false
                }
            },
        },
        beforeMount() {
            this.getLogs()
        },
        created() {
            window.addEventListener('resize', this.handleResize)
            this.handleResize();
        },
        destroyed() {
            window.removeEventListener('resize', this.handleResize)
        },
    }
</script>
<style>
    .btn i {
        text-align: center !important;
    }

    .popover-body {
        max-height: 200px;
        overflow: scroll;
    }

    .mainButton {
        width: 100%;
    }

    .table-sm th {
        padding-left: 0.5rem;
        padding-right: 0.5rem;
    }

    .table.b-table > tfoot > tr > th[aria-sort]::before, .table.b-table > thead > tr > th[aria-sort]::before {
        padding-left: 5px;
        width: .2em;
    }
</style>



// WEBPACK FOOTER //
// resources/js/views/front/Logs.vue